import Vue from "vue";
import axios from "axios";
import {computed, inject, provide, reactive, toRefs} from "@vue/composition-api";
import {listStateMerge} from "../store_helpers";
import {state as accountState} from "./account";
import {state as bookmarkState} from "./bookmark";
import {state as clientGroupState} from "./client_groups";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import i18n, {$t} from "../../i18n";
import ApiTimezones from '@/api/config/timezones';
import ApiCultures from '@/api/config/cultures';
import router from "../../router";
//todo: take from helpers
import {syncItemToList, removeFromList, formatGmtTimeDuration} from "@/plugins/formatting";

import {getCookie, setCookie, getTimezoneOffset} from "@/helpers/helpers";
import {UKU_ACTIVITIES, uku_send_event, uku_reset_cookies, uku_set_user_cookies, uku_get_cookie} from "@/helpers/uku_activity";

const protocol = process.env.VUE_APP_PROTOCOL ? process.env.VUE_APP_PROTOCOL : "";
const host = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
const baseUrl = `${protocol}://${host}`;

export const state = reactive({
    live: "",
    debug: false,
    debug_level: 0,
    region_code: "gb",
    default_locale_code: "en_GB",
    languages: [],
    ui_languages: [],
    rights_masks: {},
    formatting: {},
    google_id: "",
    xero_id: null,
    featureNotEnabledForCompany: null,
    is_mobile: false,
    countries: [],
    business_areas: [],
    calendar_types: [],
    help: [],
    help_keys: [],
    custom_fields: {},
    default_custom_fields: {},
    supplier_types: {},
    project_types: {},
    content_templates: {},
    topics: {},
    base_topics: [],
    default_jobs: {},
    default_workflows: {},
    account_jobs: {},
    account_workflows: {},
    account_job_names: {},
    client_groups: {},
    account_members: {},
    taxes: {},
    account_groups: {},
    clients: {},
    articles: {},
    progress_steps: {},
    roles: {},
    bundles: {},
    apps: {},
    web_socket_connectors: [],
    global_connection_lost: false,
    reconnect_max_tries: 5,
    reconnect_wait: 3000,
    is_mobile_dialog: false,
    page_title: null,
    current_upload_progress_loaded: 0,
    current_upload_progress_total: 0,
    initial_data_status: 0,
    baseUrl: baseUrl,
    miniUkuNoFooter: false,
    vueContext: null,
    isCalendarOpen: false,
    textForOS: '',
    isNavigationWarning: false,
    sideBarOpen: !(getCookie("sidebar") === "0"),
    selected_account_id: 0,
    freeTrialDays: 0,
    router_key: true,
    intercomData: null,
    azure_ad_app_id: null,
    timezoneNames: [],
    cultures: [],
    calendarWeeks: 2,
    info_email: 'uku@getuku.com',
    sending_email: 'uku@getuku.email'
});

const validateFormDataRow = (data, spec, prefix = "") => {
    let errors = [];

    for (let field_name in spec) {
        if (Object.prototype.hasOwnProperty.call(spec, field_name)) {
            let field_spec = spec[field_name];
            let field_path = prefix !== "" ? [prefix, field_name].join(".") : field_name;

            if (data[field_name] === undefined || data[field_name] == null || data[field_name] === "" || Array.isArray(data[field_name]) && data[field_name].length === 0) {
                if (field_spec.required !== undefined && field_spec.required)
                    errors.push({field: field_path, error_message: $t("Required field")});
                if (field_spec.requiredIf !== undefined && field_spec.requiredIf())
                    errors.push({field: field_path, error_message: $t("Required field")});
                continue;
            }

            if (field_spec.type !== undefined) {
                switch (field_spec.type) {
                    case "integer":
                        if (Number.isInteger(data[field_name])) continue;
                        errors.push({field: field_path, error_message: $t("Must be a integer")});
                        break;
                    case "date": {
                        let re = /^[1-2]{1}[0-9]{3}-[0-1]{1}[0-9]{1}-[0-3]{1}[0-9]{1}( [0-2]{1}\d:[0-5]{1}\d:[0-5]{1}\d)?$/;
                        if (re.test(data[field_name])) continue;
                        errors.push({field: field_path, error_message: $t("Must be a date")});
                        break;
                    }
                    case "email": {
                        // let re = /^[a-zA-Z0-9\+\.-]+@[a-zA-Z0-9\.-]+$/;
                        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (re.test(data[field_name])) continue;
                        errors.push({field: field_path, error_message: $t("Must be a valid e-mail address")});
                        break;
                    }
                    case "choice_single": {
                        if (field_spec.choices !== undefined && field_spec.choices != null) {
                            if (field_spec.choices.indexOf(data[field_name]) === -1)
                                errors.push({field: field_path, error_message: $t("Unknown choice")});
                        }
                        break;
                    }
                }
            }
        }
    }

    return errors;
};
const setFieldError = (obj_data, field_path, error_message) => {
    let field_arr = field_path.split(".");

    let current = obj_data;
    while (field_arr.length > 0) {
        let field_name = field_arr.shift();

        if (field_arr.length === 0) {
            if (isNaN(field_name)) {
                let prop_name = field_name + "_error";

                if (Object.prototype.hasOwnProperty.call(current, prop_name)) {
                    current[prop_name] = error_message;
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        if (isNaN(field_name)) {
            if (Object.prototype.hasOwnProperty.call(current, field_name)) {
                current = current[field_name];
            } else {
                return false;
            }
        } else {
            current = current[parseInt(field_name)];
        }
    }

    return false;
};
const setFieldErrors = (obj_data, errors, title) => {
    let global_error_messages = [];

    for (let i in errors) {
        let err = errors[i];

        if (typeof err == "string") {
            global_error_messages.push({message: err});
            continue;
        }

        if (obj_data != null && err.field != null) {
            if (!setFieldError(obj_data, err.field, err.error_message)) {
                global_error_messages.push({message: err.dialog_error_message ? err.dialog_error_message : "{0}: {1}".format(err.field, err.error_message)});
            }
        } else {
            global_error_messages.push({
                message: err.dialog_error_message ? err.dialog_error_message : err.error_message,
                details: err.details !== undefined ? err.details : null
            });
        }
    }

    if (global_error_messages.length === 0) return;

    if (global_error_messages.length === 1 && !title) {
        errorDialog.showError(global_error_messages[0]);
    } else {
        errorDialog.showError({
            message: title ? title : $t("Some errors occurred:"),
            details: "<ul><li>" + global_error_messages.map(x => x.message).join("</li><li>") + "</li></ul>"
        });
    }
};

const setLocale = function (locale_code) {
    for (let i in state.ui_languages) {
        if (typeof locale_code !== 'undefined' && state.ui_languages[i]['code'] === locale_code) {
            i18n.locale = locale_code;
            return
        }
    }
    i18n.locale = state.default_locale_code;
};
const setSessionData = async function (response) {
    let app
    let locale_code = state.default_locale_code;
    if (response && response.app) {
        app = response.app;
        state.live = app["live"];
        state.debug_level = app["debug_level"];
        state.region_code = app["region_code"];
        state.ui_languages = app["ui_languages"]; // IMPORTANT! To set up initial UI
        state.default_locale_code = app["default_locale_code"]; // IMPORTANT! To set up initial UI
        state.is_mobile = app["is_mobile"];
        state.google_id = app["google_id"];
        state.rights_masks = app["rights_masks"];
        state.formatting = app["formatting"];
        state.freeTrialDays = app["free_trial_days"]
        state.intercomData = app["intercom_data"]
        state.azure_ad_app_id = app["azure_ad_app_id"]
        state.info_email = app["info_email"]
        if (app["abiline"]) {
            state.abiline = app["abiline"]
            window.abiline = app["abiline"]
        }

        window.UkuApp = app
        window.uku_activity_url = app.uku_activity_url
        window.uku_user_id = app.uku_user_id
        window.uku_lead_id = app.uku_lead_id
        window.uku_person_id = app.uku_person_id
        window.uku_em = app.uku_em
        if (app.uku_no_track) {
            window.uku_no_track = 1
            state.uku_no_track = 1
            uku_reset_cookies("setSessionData")
        } else {
            uku_set_user_cookies(
                window.uku_user_id,
                window.uku_lead_id,
                window.uku_person_id,
                window.uku_em,
                "setSessionData"
            )
        }
        if (app.current_account) {
            accountState.current_account = app["current_account"];
            //accountState.map = new Map(app["accounts_info"].map(i => [i.id, i]));
            accountState.list = app["accounts_info"];
            app["accounts_info"].forEach(account => {
                clientGroupState.list = listStateMerge(
                    clientGroupState.list,
                    account.groups,
                    "account_id",
                    account.id,
                    "id"
                );
            });
            accountState.accounts_info = app["accounts_info"];
            bookmarkState.list = app["bookmarks"];
            state.calendarWeeks = app.current_account.data.calendar_weeks ? app.current_account.data.calendar_weeks : 2
            locale_code = accountState.current_account.locale_code;
        } else {
            locale_code = state.default_locale_code;
        }
    }

    setLocale(locale_code);
    Vue.formatting = state.formatting;
    actions.initial_data_status = 2;
    if (accountState.current_account.id !== 0) {
        for (let i = 0; i < state.web_socket_connectors.length; i++) {
            state.web_socket_connectors[i]();
        }
    }

    const uku_user_id = uku_get_cookie("uku_user_id") || window.uku_user_id
    const uku_lead_id = uku_get_cookie("uku_lead_id") || window.uku_lead_id
    const uku_person_id = uku_get_cookie("uku_person_id") || window.uku_person_id
    const uku_em = uku_get_cookie("uku_em") || window.uku_em

    try {
        // UKU-2600 :: todo metrics - ga init
        if (window.gtag) {
            const gaPayload = uku_user_id ? {
                'send_page_view': false,
                'user_id': uku_user_id,
            } : {
                'send_page_view': false,
            };
            // gaPayload.debug_mode = false
            window.gtag('consent', 'update', {'ad_user_data': 'granted', 'ad_personalization': 'granted', 'ad_storage': 'granted', 'analytics_storage': 'granted'});
            window.gtag('config', process.env.VUE_APP_GA4_MEASUREMENT_ID, gaPayload);
            if (process.env.VUE_APP_GA4_MEASUREMENT_ID) console.info('ga boot');
        }
    } catch (e) {
        console.error('ga boot', e)
    }

    try {
        // UKU-2600 :: todo metrics - fb meta init
        if (window.fbq) {
            const fbqPayload = uku_user_id ? {'external_id': uku_user_id, 'em': uku_em} : {};
            window.fbq('init', process.env.VUE_APP_FB_PIXEL_ID, fbqPayload);
            window.fbq('track', 'PageView', fbqPayload);
            if (process.env.VUE_APP_FB_PIXEL_ID) console.info('fb boot');
        }
    } catch (e) {
        console.error('fb boot', e)
    }

    try {
        // UKU-2600 :: todo metrics - linkedin init
        window.linkedin_partner_id = app.linkedin_partner_id || 0
        window.linkedin_conversion_id = app.linkedin_conversion_id || 0
        if (app.linkedin_partner_id) console.info('li boot')
    } catch (e) {
        console.error('li boot', e)
    }

    if (uku_user_id && !window.uku_no_track) {
        await uku_send_event({event: UKU_ACTIVITIES.LAST_SEEN})
    }

};
const clearValidationErrors = function (form_data) {
    if (Array.isArray(form_data)) {
        for (let row of form_data) {
            clearValidationErrors(row);
        }
    }
    for (let prop in form_data) {
        if (Object.prototype.hasOwnProperty.call(form_data, prop)) {
            if (prop.endsWith("_error")) form_data[prop] = null;
            else if (Array.isArray(form_data[prop])) {
                clearValidationErrors(form_data[prop]);
                /*for (let i = 0; i < form_data[prop].length - 1; i++) {
                    clearValidationErrors(form_data[prop][i]);
                }*/
            }
        }
    }
};

export const myDebug = {
    level() {
        return state.debug_level ? state.debug_level : 0
    }
};

export const actions = {
    toggleCalendar(isCalendarOpen) {
        state.isCalendarOpen = isCalendarOpen
    },

    async fetchTimezones() {
        if (state.timezoneNames.length) {
            return
        }

        try {
            const data = await ApiTimezones.getTimezones()
            state.timezoneNames = data.timezones
        } catch (e) {
            errorDialog.showError(e)
        }
    },

    async fetchCultures() {
        if (state.cultures.length) {
            return
        }

        try {
            const data = await ApiCultures.getCultures()
            state.cultures = data.cultures
        } catch (e) {
            errorDialog.showError(e)
        }
    },

    setTextBasedOnOS() {
        if (navigator.userAgent.indexOf("Win") !== -1) return state.textForOS = 'CTRL';
        if (navigator.userAgent.indexOf("Mac") !== -1) return state.textForOS = 'CMD';
        if (navigator.userAgent.indexOf("Linux") !== -1) return state.textForOS = 'CTRL';
        if (navigator.userAgent.indexOf("Android") !== -1) return "";
        if (navigator.userAgent.indexOf("like Mac") !== -1) return "";
    },

    fetchInitialData(force = false) {
        return new Promise(function (resolve, reject) {
            // session data is included to the page
            if (window.session_data != null) {
                setSessionData(window.session_data);
                resolve();
                return;
            }

            // session is already loading/loaded
            if (actions.initial_data_status > 0 && !force) {
                resolve();
                return;
            }

            // load session
            actions.initial_data_status = 1;
            axios
                .get(Vue.config.url_prefix + "/api/vue/generate")
                .then(async function (resp) {
                    await setSessionData(resp.data);
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    refreshAccountsInfo() {
        return new Promise((resolve, reject) => {
            axios
                .get(Vue.config.url_prefix + "/api/vue/generate")
                .then(function (resp) {
                    let app = resp.data.app;

                    if (app.current_account) {
                        //todo: refactor - we don't need both list and accounts_info - remove list
                        accountState.list = app["accounts_info"];
                        accountState.accounts_info = app["accounts_info"];

                        //todo: refactor - use classifiers - just clear cache and do not load anything
                        app["accounts_info"].forEach(account => {
                            clientGroupState.list = listStateMerge(
                                clientGroupState.list,
                                account.groups,
                                "account_id",
                                account.id,
                                "id"
                            );
                        });
                    }
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    fetchClassifiers(params) {
        let general_classifiers = [
            "countries",
            "calendar_types",
            "languages",
            "ui_languages",
            "business_areas",
            "base_topics",
            "help",
            "help_keys"
        ];
        return new Promise(function (resolve, reject) {
            // check if classifier is already loaded
            const not_loaded = [];
            if (params.force?.default === true) {
                for (let force_type of params.force.types) {
                    not_loaded.push(force_type);
                }
            }
            for (let i in params.types) {
                let t = params.types[i];
                if (general_classifiers.indexOf(t) >= 0) {
                    if (state[t] == null || (Array.isArray(state[t]) && state[t].length === 0)) not_loaded.push(t);
                } else {
                    if (params.account_id) {
                        if (state[t][params.account_id] === undefined) not_loaded.push(t);
                    } else {
                        for (let j in accountState.accounts_info) {
                            if (state[t][accountState.accounts_info[j].id] === undefined) {
                                if (not_loaded.indexOf(t) === -1) not_loaded.push(t);
                            }
                        }
                    }
                }
            }

            // all good, nothing to load
            if (not_loaded.length === 0) {
                resolve();
                return;
            }
            let req_params = {types: not_loaded.join(",")};
            if (params.account_id) req_params.account_id = params.account_id;
            if (params.include_inactive_account) req_params.include_inactive_account = 1;
            if (params.is_client_portal) req_params.is_client_portal = params.is_client_portal;

            axios
                .get(Vue.config.url_prefix + "/api/classificators/", {params: req_params})
                .then(function (resp) {
                    // update state
                    for (let i of not_loaded) {
                        if (!resp.data[i]) {
                            console.error('Load classificators :: Missing key in response:' + i, req_params);
                            continue
                        }
                        if (general_classifiers.indexOf(i) >= 0) {
                            state[i] = resp.data[i];
                        } else {
                            let res = resp.data[i].reduce(function (r, a) {
                                r[a.account_id] = r[a.account_id] || [];
                                r[a.account_id].push(a);
                                return r;
                            }, {});
                            if (params.account_id && res[params.account_id] === undefined)
                                res[params.account_id] = [];
                            state[i] = res;
                        }
                    }
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    clearClassifiersCache(key, account_id = null) {
        if (account_id) {
            delete state[key][account_id];
        } else {
            state[key] = [];
        }
    },
    syncToClassifiersCache(key, item, account_id = null) {
        if (account_id) {
            if (Object.keys(state[key]).length === 0) {
                return
            }

            if (state[key][account_id] === undefined)
                Vue.set(state[key], account_id, [item]);
            else
                syncItemToList(state[key][account_id], item);
        } else {
            if (state["key"].length > 0) syncItemToList(state[key], item);
        }
    },
    removeFromClassifiersCache(key, item_id, account_id = null) {
        if (account_id) {
            if (state[key][account_id] !== undefined) removeFromList(state[key][account_id], item_id);
        } else {
            if (state["key"].length > 0) removeFromList(state[key], item_id);
        }
    },
    //todo: use sync instead append
    appendClassifiersCache(key, new_item, account_id = null) {
        if (account_id) {
            if (state[key][account_id] !== undefined) state[key][account_id].push(new_item);
        } else {
            if (state["key"].length > 0) state["key"].push(new_item);
        }
    },
    openTargetBlank(u) {
        window.open(u, "_blank");
    },
    setFieldError: setFieldError,
    setFieldErrors: setFieldErrors,
    handleErrorResponse(obj_data, ex, child_obj_name = null) {
        if (typeof ex === "string") {
            errorDialog.showError(ex);
            return;
        }

        if (ex.response && ex.response.status) {
            if (ex.response.status === 400 && ex.response.data) {
                if (ex.response.data.error_type === "form_validation") {
                    setFieldErrors(obj_data, ex.response.data.errors, ex.response.data.title);
                    return
                }
            }
        }

        errorDialog.showError(ex);
    },
    clearValidationErrors: clearValidationErrors,
    validateFormData(form_data, spec) {
        clearValidationErrors(form_data);
        let errors = [];

        if (Array.isArray(form_data)) {
            for (let i = 0; i < form_data.length; i++) {
                let tmp_errors = validateFormDataRow(form_data[i], spec, i.toString());
                errors = errors.concat(tmp_errors);
            }
        } else {
            let tmp_errors = validateFormDataRow(form_data, spec);
            errors = errors.concat(tmp_errors);
        }

        if (errors.length > 0) {
            setFieldErrors(form_data, errors);
            return false;
        }
        return true;
    },
    hasValidationErrors(form_data) {
        for (let prop in form_data) {
            if (Object.prototype.hasOwnProperty.call(form_data, prop)) {
                if (prop.endsWith("_error") && form_data[prop] != null) return true;
            }
        }
        return false;
    },
    showFeatureNotEnabled(company) {
        state.featureNotEnabledForCompany = company;
    },
    closeFeatureNotEnabled() {
        state.featureNotEnabledForCompany = null;
    },
    async deleteFile(form_data, f, related_object, related_type, file_deleted) {
        let params = {}
        let endpoint = ''
        switch (related_type) {
            case "task":
                params.task_id = related_object.value.id
                params.task_virtual_id = related_object.value.virtual_id
                endpoint = 'task_attachment'
                break;
            case "email_automation_template":
                params.template_id = related_object.value.id;
                endpoint = 'email_automation/attachment'
                break;
            case "email_task":
                endpoint = 'email_task/attachment'
                break;
            default:
                return;
        }

        if (f.id === 0) {
            for (let i = 0; i < form_data.value.files.length; i++) {
                if (form_data.value.files[i].temp_id === f.temp_id) {
                    form_data.value.files.splice(i, 1);
                    break;
                }
            }
        } else {
            try {
                const data = await axios.delete(`/${endpoint}/${f.id}`, {params})
                if (file_deleted) {
                    file_deleted(data.data.deleted_attachment_id)
                }
            } catch (ex) {
                errorDialog.showError(ex);
            }
        }
    },
    uploadFile(params) {
        return new Promise(function (resolve, reject) {
            state.current_upload_progress_loaded = 0;
            state.current_upload_progress_total = 0;

            let url = Vue.config.url_prefix;

            let form_data = new FormData();
            form_data.append("userfile", params.file);
            form_data.append("userfilename", params.file.name);

            switch (params.related_type) {
                case "task":
                    url += "/api/task_attachment/";
                    form_data.append("task_id", params.task_id);
                    form_data.append("task_virtual_id", params.task_virtual_id);
                    form_data.append("save_temporary", params.save_temporary);
                    break;
                case "note":
                    url += "/api/note_attachment/";
                    form_data.append("note_id", params.note_id);
                    break;
                case "email_automation_template":
                    url += "/api/email_automation/attachment"
                    if (params.template_id) {
                        form_data.append('template_id', params.template_id)
                    } else {
                        form_data.append('template_id', 0)
                    }
                    break;
                case "email_task":
                    url += "/api/email_task/attachment"
                    form_data.append('email_task_id', params.task_id)
                    break;
                case "portal_logo":
                case "portal_icon":
                    url += "/api/a/{0}/features/{1}/upload/".format(params.account_id, params.feature_id)
                    form_data.append('feature_id', params.feature_id)
                    form_data.append('related_type', params.related_type)
                    break;
                case "signature_logo":
                    url += "/api/email_signature/{0}/logo_upload/?".format(params.account_id)
                    form_data.append('feature_id', params.feature_id)
                    form_data.append('related_type', params.related_type)
                    break;
                case "import_session":
                    url += "/api/import_session/{0}/upload_file".format(params.import_session_id);
                    form_data.append("import_session_id", params.import_session_id);
                    break;

                case 'client_workflow':
                    url += "/api/import_client_workflow/{0}/upload_file".format(params.import_session_id);
                    form_data.append("import_session_id", params.import_session_id);
                    break;
                case 'project_workflow':
                    url += "/api/import_project_workflow/{0}/upload_file".format(params.import_session_id);
                    form_data.append("import_session_id", params.import_session_id);
                    break;

                default:
                    return;
            }

            let xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.withCredentials = true;
            xhr.setRequestHeader("X-XSRFToken", getCookie("_xsrf"));

            xhr.upload.onprogress = function (e) {
                if (e.lengthComputable) {
                    state.current_upload_progress_loaded = e.loaded;
                    state.current_upload_progress_total = e.total;
                }
            };

            xhr.onload = function () {
                if (xhr.status === 200) {
                    if (xhr.responseText.substring(0, 1) !== "{") {
                        reject(xhr);
                    } else {
                        resolve(JSON.parse(xhr.responseText));
                    }
                } else {
                    reject(xhr);
                }
                state.current_upload_progress_loaded = 0;
                state.current_upload_progress_total = 0;
            };

            xhr.onerror = function () {
                if (xhr.status === 0) reject($t("Unknown network error"));
                else reject(xhr);
            };

            xhr.send(form_data);
        });
    },
    showGlobalConnectionLost() {
        if (state.global_connection_lost) return;

        state.global_connection_lost = true;

        errorDialog.showError({
            message: $t("Could not connect to the service"),
            button_text: $t("Reload this page"),
            callback: function () {
                window.location.reload(1);
            }
        });
    },
    fetchSecurityObject(params) {
        return new Promise(function (resolve, reject) {
            let url =
                params.security_id !== undefined
                    ? "/api/security_object/security/{0}".format(params.security_id)
                    : "/api/security_object/{0}/{1}".format(params.object, params.id);

            axios
                .get(Vue.config.url_prefix + url)
                .then(function (resp) {
                    resolve(resp.data);
                })
                .catch(function (ex) {
                    state.is_loading = false;
                    reject(ex);
                });
        });
    },
    setMiniUkuNoFooter(noFooter) {
        state.miniUkuNoFooter = noFooter;
    },
    systemLog(status, source, action, data) {
        return new Promise(function (resolve) {
            let req_data = {status, source, action, data};
            axios
                .post(Vue.config.url_prefix + "/api/system_log/", req_data)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    //Intentionally ignore error
                    resolve();
                });
        });
    },
    setPageTitle(title) {
        state.page_title = title;
    },
    toggleSideBar(open) {
        state.sideBarOpen = open;
        if (open) {
            setCookie("sidebar", 1, 99);
        } else {
            setCookie("sidebar", 0);
        }
    },
    navigateReload(value) {
        try {
            if (value && value.path && value.path.length && value.path.includes('target=blank')) {
                let url = value.path;
                return window.open(url, "_blank");
            }
        } catch (ex) {
            console.error(ex)
        }

        state.router_key = false
        router.push(value).then(() => {
            state.router_key = true
        }).catch(() => {
            state.router_key = true
        })
    }
};

export const getters = {
    users: computed(() => state.list),
    timezones: computed(() => {
        const mappedTimezones = state.timezoneNames.map(timezone => {
            let timezoneOffset = getTimezoneOffset(timezone)
            let label = ''

            if (timezoneOffset === null) {
                timezoneOffset = 0
            }

            const timezoneOffsetFormatted = formatGmtTimeDuration(timezoneOffset, '')
            label = `(UTC${timezoneOffsetFormatted}) `

            label += timezone

            return {
                value: timezone,
                title: label,
                offset: timezoneOffset
            }
        })

        mappedTimezones.sort(function (a, b) {
            return a.offset - b.offset || a.title.localeCompare(b.title)
        })

        return mappedTimezones
    }),

    cultures: computed(() => {
        return state.cultures
    }),

    getTaxes() {
        return state.taxes
    }

    //wizard_mode: computed(() => state.wizard),
};

export const key = Symbol("AppModule");

export const provideApp = () =>
    provide(key, {
        ...toRefs(state),
        ...toRefs(getters),
        ...actions,
        ...myDebug,
    });

export default () => inject(key);
